import "./completenessChart.css";

const CompletenssChart = ({ value, color }) => {
  return (
    <div className='completenessChart'>
      <div>
        <div className='chartDiv342'>
          <div className='firstCircle22'>
            <div className='outterCircleBack22'>
              <div className='innerCircleBack22' style={{ background: `conic-gradient(${color}  ${value===0? 1 * 3.6: value*3.6}deg, #f9f9f9 0deg)` }}>
                <div>
                  <p style={{ color: `${color}`, fontWeight: "600", fontSize: "1.4rem" }}>{value} %</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompletenssChart;
